/**
 * Remote Assessment provenance. A record counts as Remote when any of its images or measurements
 * came from a shared call window (`captureSource: 'screen-share'`), including mixed records.
 * Records saved before capture sources existed carry no marker and are never Remote.
 */

export const REMOTE_CAPTURE_LABEL = 'Remote';
export const REMOTE_CAPTURE_DESCRIPTION = 'Captured via screen share (Remote Assessment)';

type CapturedViewLike = { captureSource?: string; [key: string]: unknown };
type PostureLike = { captured?: Record<string, CapturedViewLike | null | undefined> | null } | null | undefined;

export function isRemotePostureAnalysis(analysis: PostureLike): boolean {
  const captured = analysis?.captured;
  if (!captured) return false;
  return Object.values(captured).some((view) => view?.captureSource === 'screen-share');
}

export function isRemoteSopAssessment(assessment: Record<string, unknown> | null | undefined): boolean {
  if (!assessment) return false;
  return Object.entries(assessment).some(
    ([key, value]) => key.endsWith('_captureSource') && value === 'screen-share',
  );
}
